export default __webpack_public_path__ + "static/media/home_thumb_WR_.6db42c3c.png";